import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { API } from '_helpers';

interface Props {
  data: CSection2;
}

const Section2: React.FC<Props> = ({ data }) => {
  return (
    <Container sx={{ py: 10, position: 'relative' }}>
      <Grid container>
        <Grid item xs={12} md={3}>
          <Stack
            spacing={4}
            sx={{
              '&>p': { fontSize: { xs: 18, md: 24 } },
              px: { xs: 0, md: 10 },
              height: 1,
            }}
          >
            <Stack
              sx={{
                height: 1,
                width: 1200,
                position: 'absolute',
                top: '100px',
                left: '-600px',
                background:
                  'radial-gradient(circle, rgba(51,57,114,0.8) 0%, rgba(252,70,107,0) 60%)',
                zIndex: 0,
              }}
            ></Stack>
            <Stack
              sx={{
                height: 1,
                width: 1200,
                position: 'absolute',
                top: '300px',
                left: '-300px',
                background:
                  'radial-gradient(circle, rgba(51,57,114,0.6) 0%, rgba(252,70,107,0) 60%)',
                zIndex: 0,
              }}
            ></Stack>
            <Stack
              sx={{
                height: 1,
                width: 1300,
                position: 'absolute',
                top: '-300px',
                right: '-400px',
                background:
                  'radial-gradient(circle, rgba(233, 170, 76,0.2) 0%, rgba(252,70,107,0) 60%)',
                zIndex: 0,
              }}
            ></Stack>
            <Stack
              sx={{
                height: 1,
                width: 1300,
                position: 'absolute',
                top: '-100px',
                right: '-400px',
                background:
                  'radial-gradient(circle, rgba(51,57,114,0.7) 0%, rgba(252,70,107,0) 60%)',
                zIndex: 0,
              }}
            ></Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md={9} sx={{ position: 'relative' }}>
          <Stack
            justifyContent="space-evenly"
            spacing={{ xs: 4, md: 8 }}
            direction={{ xs: 'column', sm: 'row', md: 'column' }}
            sx={{ px: { xs: 0, md: 4 } }}
          >
            <Stack
              sx={{
                width: { xs: 1, md: 0.7 },
                '&>p': { fontSize: { xs: 18, md: 24 } },
              }}
              spacing={3}
            >
              <Typography color="text.secondary">{data?.subtitle}</Typography>
              <Typography
                color="text.primary"
                variant="h1"
                sx={{ typography: { xs: 'h2', md: 'h1' } }}
              >
                {data?.title}
              </Typography>
              <Typography color="text.secondary" sx={{ pl: { xs: 0, md: 10 } }}>
                {data?.description}
              </Typography>
            </Stack>
            <Stack
              sx={{
                '&>p': { fontSize: { xs: 18, md: 24 } },
                pl: { xs: 0, md: 10 },
              }}
            >
              <Grid container spacing={{ xs: 4, md: 12 }}>
                {data?.cards?.map((el, i) => (
                  <Grid item xs={12} md={6} key={i}>
                    <Stack spacing={3}>
                      <Stack
                        sx={{
                          width: 70,
                          height: 70,
                          position: 'relative',
                        }}
                      >
                        <Image
                          alt={el.media.alternativeText}
                          src={`${API}${el.media.url}`}
                          layout="fill"
                          objectFit="contain"
                        />
                      </Stack>
                      <Typography variant="h3">{el?.title}</Typography>
                      <Typography color="text.secondary">
                        {el?.description}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Section2;
